import React from "react"

import QpBackPanel from './svg/qp-back-panel'
import QpFrontPanel from './svg/qp-front-panel'
import QpRightPanel from './svg/qp-right-panel'
import QpLeftPanel from './svg/qp-left-panel'
import QpBottomPanel from './svg/qp-bottom-panel'
import QpCenterPanel from './svg/qp-center-panel'
import QpTopPanel from './svg/qp-top-panel'
import QpTopZipper from './svg/qp-zipper'
import QpHardware from './svg/qp-hardware'
import QpZipperPuller from './svg/qp-zipper-puller'
import QpLabel from './svg/qp-label'
import QpBackBottomkPanel from './svg/qp-back-bottom-panel'
import QpBackTopPanel from './svg/qp-back-top-panel'
import QpBackBackPanel from './svg/qp-back-back-panel'
import QpBackFrontPanel from './svg/qp-back-front-panel'
import QpBackHardware from './svg/qp-back-hardware'
import QpBackZipper from './svg/qp-back-zipper'
import QpBackZipperPuller from './svg/qp-back-zipper-puller'

export const SketchTeFront = ({ size, getColor, getPattern, getLineColor, showSoftZipper, showPointPattern, currrentComposition, currentStage }) => (
  <svg id="front"  viewBox="-130 -50 750 750" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="paint0_linear_817_2" x1="461.001" y1="528.454" x2="493.205" y2="527.78" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset=".349" stop-opacity=".034"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint0_linear_270_4" x1="499.001" y1="535.454" x2="531.205" y2="534.78" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset="0.348958" stop-opacity="0.0344832"/>
        <stop offset="0.9996"/>
      </linearGradient>
      <linearGradient id="paint0_linear_270_4" x1="15.684" y1="287.65" x2="50.065" y2="285.394" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_270_4" x1="-1.492" y1="320.314" x2="34.792" y2="309.833" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint2_linear_270_4" x1="-.078" y1="319.904" x2="33.359" y2="310.246" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_270_4" x1="7.973" y1="295.643" x2="27.511" y2="289.999" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint4_linear_270_4" x1="11.281" y1="322.757" x2="15.469" y2="321.548" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint5_linear_270_4" x1="14.877" y1="323.759" x2="20.192" y2="322.223" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint6_linear_270_4" x1="19.776" y1="324.075" x2="25.091" y2="322.54" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint7_linear_270_4" x1="18.458" y1="291.639" x2="44.361" y2="279.679" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint8_linear_270_4" x1="174.738" y1="65.175" x2="208.044" y2="56.355" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint9_linear_270_4" x1="151.239" y1="29.385" x2="151.654" y2="67.151" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint10_linear_270_4" x1="151.256" y1="30.858" x2="151.639" y2="65.659" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint11_linear_270_4" x1="172.488" y1="45.093" x2="172.712" y2="65.427" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint12_linear_270_4" x1="145.475" y1="41.044" x2="145.523" y2="45.402" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint13_linear_270_4" x1="143.55" y1="44.242" x2="143.611" y2="49.773" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint14_linear_270_4" x1="141.937" y1="48.878" x2="141.998" y2="54.41" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint15_linear_270_4" x1="175.858" y1="62.771" x2="203.937" y2="57.715" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint16_linear_270_4" x1="238.193" y1="72.198" x2="208.025" y2="55.557" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint17_linear_270_4" x1="271.192" y1="47.476" x2="258.395" y2="83.013" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint18_linear_270_4" x1="270.692" y1="48.862" x2="258.9" y2="81.609" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint19_linear_270_4" x1="245.961" y1="55.334" x2="239.071" y2="74.469" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint20_linear_270_4" x1="272.807" y1="60.382" x2="271.331" y2="64.483" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint21_linear_270_4" x1="273.575" y1="64.035" x2="271.701" y2="69.24" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint22_linear_270_4" x1="273.576" y1="68.945" x2="271.702" y2="74.15" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint23_linear_270_4" x1="237.083" y1="70.752" x2="212.222" y2="56.755" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint0_linear_654_3299" x1="195.86" y1="27.995" x2="224.563" y2="47.051" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_654_3299" x1="162.205" y1="54.189" x2="174.737" y2="18.558" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
        </linearGradient>
      <linearGradient id="paint2_linear_654_3299" x1="162.695" y1="52.8" x2="174.243" y2="19.965" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_654_3299" x1="187.377" y1="46.143" x2="194.125" y2="26.958" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint4_linear_654_3299" x1="160.494" y1="41.296" x2="161.94" y2="37.184" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint5_linear_654_3299" x1="159.699" y1="37.648" x2="161.534" y2="32.429" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint6_linear_654_3299" x1="159.662" y1="32.739" x2="161.497" y2="27.52" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint7_linear_654_3299" x1="196.142" y1="30.626" x2="221.106" y2="44.437" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint8_linear_654_3299" x1="258.273" y1="41.648" x2="224.357" y2="47.709" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint9_linear_654_3299" x1="281.583" y1="75.865" x2="280.888" y2="38.103" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint10_linear_654_3299" x1="281.555" y1="74.392" x2="280.915" y2="39.595" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint11_linear_654_3299" x1="260.218" y1="60.315" x2="259.844" y2="39.983" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint12_linear_654_3299" x1="287.261" y1="64.165" x2="287.18" y2="59.806" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint13_linear_654_3299" x1="289.162" y1="60.952" x2="289.06" y2="55.421" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint14_linear_654_3299" x1="290.74" y1="56.303" x2="290.638" y2="50.773" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint15_linear_654_3299" x1="256.825" y1="42.75" x2="228.786" y2="48.014" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <pattern id="garden" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('garden')} x="0" y="0" width="500" height="700"/>
      </pattern>
      <pattern id="rust" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('rust')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="green" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('green')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="beige" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('beige')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="grey" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('grey')} x="0" y="0" width="500" height="700"/>
      </pattern>
      <pattern id="violet" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('violet')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="black" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('black')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="webbing" patternUnits="userSpaceOnUse" width="205" height="200">
        <image xlinkHref={getPattern('webbing')} x="0" y="-10" width="205" height="200"/>
      </pattern>
    </defs>
    <g fill="none" fillRule="evenodd">
      <QpBackPanel
        fillColor={getColor(currrentComposition.case[2].color)}
        strokeColor={getLineColor(currrentComposition.case[2].color)}
      />
      <QpTopPanel
        fillColor={getColor(currrentComposition.case[2].color)}
        strokeColor={getLineColor(currrentComposition.case[2].color)}
      />

      {/* Front Upper Panel */}
      <QpFrontPanel
        fillColor={getColor(currrentComposition.case[0].color)}
        strokeColor={getLineColor(currrentComposition.case[0].color)}
      />

      {/* Front Lower Panel */}
      <QpRightPanel
        fillColor={getColor(currrentComposition.case[1].color)}
        strokeColor={getLineColor(currrentComposition.case[1].color)}
      />
      <QpLeftPanel
        fillColor={getColor(currrentComposition.case[1].color)}
        strokeColor={getLineColor(currrentComposition.case[1].color)}
      />
      <QpCenterPanel
        fillColor={getColor(currrentComposition.case[1].color)}
        strokeColor={getLineColor(currrentComposition.case[1].color)}
      />

      {/* Side Lower Panel */}
      <QpBottomPanel
        fillColor={getColor(currrentComposition.case[3].color)}
        strokeColor={getLineColor(currrentComposition.case[3].color)}
      />
      
      <QpTopZipper
        bgColor={currrentComposition.case[5].color === 'white_z' ? '#fff' : '#000'}
        fillColor={currrentComposition.case[5].color === 'white_z' ? '#f7f7f7' : '#1c1c1c'}
        strokeColor={currrentComposition.case[5].color === 'white_z' ? '#d1d1d1' : '#232323'}
      />
      <QpHardware />
      <QpZipperPuller
        fillColor={getColor(currrentComposition.case[6]?.color)}
        showSoft={showSoftZipper(currrentComposition.case[6].color)}
      />
      <QpLabel color={currrentComposition.case[7]?.color} />
    </g>
  </svg>
)

export const SketchTeBack = ({ size, getColor, showSoftZipper, getLineColor, currrentComposition, currentStage, getPattern }) => (
  <svg id="back" viewBox="-130 -50 750 750" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs key={currentStage}>
    <linearGradient id="paint0_linear_817_2" x1="461.001" y1="528.454" x2="493.205" y2="527.78" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset=".349" stop-opacity=".034"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint0_linear_270_4" x1="499.001" y1="535.454" x2="531.205" y2="534.78" gradientUnits="userSpaceOnUse">
        <stop/>
        <stop offset="0.348958" stop-opacity="0.0344832"/>
        <stop offset="0.9996"/>
      </linearGradient>
      <linearGradient id="paint0_linear_270_4" x1="15.684" y1="287.65" x2="50.065" y2="285.394" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_270_4" x1="-1.492" y1="320.314" x2="34.792" y2="309.833" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint2_linear_270_4" x1="-.078" y1="319.904" x2="33.359" y2="310.246" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_270_4" x1="7.973" y1="295.643" x2="27.511" y2="289.999" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint4_linear_270_4" x1="11.281" y1="322.757" x2="15.469" y2="321.548" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint5_linear_270_4" x1="14.877" y1="323.759" x2="20.192" y2="322.223" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint6_linear_270_4" x1="19.776" y1="324.075" x2="25.091" y2="322.54" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint7_linear_270_4" x1="18.458" y1="291.639" x2="44.361" y2="279.679" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint8_linear_270_4" x1="174.738" y1="65.175" x2="208.044" y2="56.355" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint9_linear_270_4" x1="151.239" y1="29.385" x2="151.654" y2="67.151" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint10_linear_270_4" x1="151.256" y1="30.858" x2="151.639" y2="65.659" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint11_linear_270_4" x1="172.488" y1="45.093" x2="172.712" y2="65.427" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint12_linear_270_4" x1="145.475" y1="41.044" x2="145.523" y2="45.402" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint13_linear_270_4" x1="143.55" y1="44.242" x2="143.611" y2="49.773" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint14_linear_270_4" x1="141.937" y1="48.878" x2="141.998" y2="54.41" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint15_linear_270_4" x1="175.858" y1="62.771" x2="203.937" y2="57.715" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint16_linear_270_4" x1="238.193" y1="72.198" x2="208.025" y2="55.557" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint17_linear_270_4" x1="271.192" y1="47.476" x2="258.395" y2="83.013" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint18_linear_270_4" x1="270.692" y1="48.862" x2="258.9" y2="81.609" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint19_linear_270_4" x1="245.961" y1="55.334" x2="239.071" y2="74.469" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint20_linear_270_4" x1="272.807" y1="60.382" x2="271.331" y2="64.483" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint21_linear_270_4" x1="273.575" y1="64.035" x2="271.701" y2="69.24" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint22_linear_270_4" x1="273.576" y1="68.945" x2="271.702" y2="74.15" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint23_linear_270_4" x1="237.083" y1="70.752" x2="212.222" y2="56.755" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint0_linear_654_3299" x1="195.86" y1="27.995" x2="224.563" y2="47.051" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint1_linear_654_3299" x1="162.205" y1="54.189" x2="174.737" y2="18.558" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
        </linearGradient>
      <linearGradient id="paint2_linear_654_3299" x1="162.695" y1="52.8" x2="174.243" y2="19.965" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint3_linear_654_3299" x1="187.377" y1="46.143" x2="194.125" y2="26.958" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint4_linear_654_3299" x1="160.494" y1="41.296" x2="161.94" y2="37.184" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint5_linear_654_3299" x1="159.699" y1="37.648" x2="161.534" y2="32.429" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint6_linear_654_3299" x1="159.662" y1="32.739" x2="161.497" y2="27.52" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint7_linear_654_3299" x1="196.142" y1="30.626" x2="221.106" y2="44.437" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint8_linear_654_3299" x1="258.273" y1="41.648" x2="224.357" y2="47.709" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint9_linear_654_3299" x1="281.583" y1="75.865" x2="280.888" y2="38.103" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint10_linear_654_3299" x1="281.555" y1="74.392" x2="280.915" y2="39.595" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint11_linear_654_3299" x1="260.218" y1="60.315" x2="259.844" y2="39.983" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint12_linear_654_3299" x1="287.261" y1="64.165" x2="287.18" y2="59.806" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint13_linear_654_3299" x1="289.162" y1="60.952" x2="289.06" y2="55.421" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint14_linear_654_3299" x1="290.74" y1="56.303" x2="290.638" y2="50.773" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <linearGradient id="paint15_linear_654_3299" x1="256.825" y1="42.75" x2="228.786" y2="48.014" gradientUnits="userSpaceOnUse">
        <stop stop-color="#fff"/>
        <stop offset="1"/>
      </linearGradient>
      <pattern id="garden" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('garden')} x="0" y="0" width="500" height="700"/>
      </pattern>
      <pattern id="rust" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('rust')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="green" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('green')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="beige" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('beige')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="grey" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('grey')} x="0" y="0" width="500" height="700"/>
      </pattern>
      <pattern id="violet" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('violet')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="black" patternUnits="userSpaceOnUse" width="500" height="700">
        <image xlinkHref={getPattern('black')} x="0" y="-5" width="500" height="700"/>
      </pattern>
      <pattern id="webbing" patternUnits="userSpaceOnUse" width="205" height="200">
        <image xlinkHref={getPattern('webbing')} x="0" y="-10" width="205" height="200"/>
      </pattern>
    </defs>
    <g fill="none" fillRule="evenodd">
      {/* Side Lower Panel */}
      <QpBackBottomkPanel
        fillColor={getColor(currrentComposition.case[3].color)}
        strokeColor={getLineColor(currrentComposition.case[3].color)}
      />

      {/* Side Upper Panel */}
      <QpBackTopPanel
        fillColor={getColor(currrentComposition.case[2].color)}
        strokeColor={getLineColor(currrentComposition.case[2].color)}
      />
      <QpBackBackPanel
        fillColor={getColor(currrentComposition.case[2].color)}
        strokeColor={getLineColor(currrentComposition.case[2].color)}
      />

      {/* Back Panel */}
      <QpBackFrontPanel
        fillColor={getColor(currrentComposition.case[4].color)}
        strokeColor={getLineColor(currrentComposition.case[4].color)}
      />

      <QpBackZipper
        bgColor={currrentComposition.case[5].color === 'white_z' ? '#fff' : '#000'}
        fillColor={currrentComposition.case[5].color === 'white_z' ? '#f7f7f7' : '#1c1c1c'}
        strokeColor={currrentComposition.case[5].color === 'white_z' ? '#d1d1d1' : '#232323'}
      />
      <QpBackHardware />
      <QpBackZipperPuller
        fillColor={getColor(currrentComposition.case[6]?.color)}
        showSoft={showSoftZipper(currrentComposition.case[6].color)}
      />
    </g>
  </svg>
)
